import { Component, OnInit, Input, Output, EventEmitter, OnChanges, DoCheck } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { SalesCategoryService } from '../../../service/sales-category/sales-category.service';
import { SalesGroupService } from '../../../service/sales-group/sales-group.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9164',
  templateUrl: './wa9164.component.html',
  styleUrls: ['./wa9164.component.scss']
})
export class Wa9164Component implements OnChanges {
  public componentTitle = 'WA9164:売上摘要マスタ登録';

  public salescategories: any;

  public salesgroupCd: FormControl;
  public salesgroupTx: FormControl;
  public salescategoryId: FormControl;
  public salesgroupunitTx: FormControl;

  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;
  private isSubmitButtonEnabled = false;
  constructor(private salescategoryService: SalesCategoryService, private salesgroupService: SalesGroupService, private commonService: CommonService) {
    (this.salesgroupCd = new FormControl('', [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.maxLength(validation.salesgroupCd.maxLength)
    ])),
      (this.salesgroupTx = new FormControl('', [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.salesgroupTx.maxLength)
      ])),
      (this.salescategoryId = new FormControl('', [Validators.required])),
      (this.salesgroupunitTx = new FormControl('', [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.salesgroupunitTx.maxLength)
      ])),
      (this.working = true);
    this.salescategoryService
      .get()
      .then(outputJson => {
        this.salescategories = outputJson.salescategories;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onSubmit() {
    var salesgroupCd = this.salesgroupCd.value.trim();
    var salesgroupTx = this.salesgroupTx.value.trim();
    var salescategoryId = this.salescategoryId.value.trim();
    var salesgroupunitTx = this.salesgroupunitTx.value.trim();
    let errors = false;
    if (!this.isSubmitButtonEnabled) return;
    if (this.salesgroupCd.errors !== null) {
      this.salesgroupCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.salesgroupTx.errors !== null) {
      this.salesgroupTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.salescategoryId.errors !== null) {
      this.salescategoryId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.salesgroupunitTx.errors !== null) {
      this.salesgroupunitTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    const updprogramCd: string = JSON.parse(sessionStorage.getItem('loginResult'))['user']['userId'];
    this.salesgroupService
      .post(salesgroupCd, salesgroupTx, salescategoryId, salesgroupunitTx, updprogramCd)
      .then(outputJson => {
        this.working = false;
        this.isDelayHide = true;
        this.salesgroupCd = new FormControl('', [
          Validators.pattern(validation.halfBlankOnly),
          Validators.pattern(validation.code39),
          Validators.maxLength(validation.salesgroupCd.maxLength)
        ]);
        this.salesgroupTx = new FormControl('', [
          Validators.pattern(validation.emBlankOnly),
          Validators.pattern(validation.halfBlankOnly),
          Validators.maxLength(validation.salesgroupTx.maxLength)
        ]);
        (this.salescategoryId = new FormControl('', [Validators.required])),
          this.salesgroupunitTx = new FormControl('', [
            Validators.pattern(validation.halfBlankOnly),
            Validators.pattern(validation.code39),
            Validators.maxLength(validation.salesgroupunitTx.maxLength)
          ]);
        this.cancel();
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';

    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    } else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
      this.salesgroupCd = new FormControl('', [
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.code39),
        Validators.maxLength(validation.salesgroupCd.maxLength)
      ]);
      this.salesgroupTx = new FormControl('', [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.salesgroupTx.maxLength)
      ]);
      this.salescategoryId = new FormControl('', [Validators.required]);
      this.salesgroupunitTx = new FormControl('', [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.salesgroupunitTx.maxLength)
      ]);
    }
  }

  ngDoCheck() {
    if (this.salesgroupCd.value !== '' && this.salesgroupTx.value !== '' && this.salescategoryId.value !== '' && this.salesgroupunitTx.value !== '') {
      this.isSubmitButtonEnabled = true;
    } else {
      this.isSubmitButtonEnabled = false;
    }
  }

  initDatas() {
    this.errorInfo = '';
    var salesgroupCd = '';
    var salesgroupTx = '';
    var salescategoryId = '';
    var salesgroupunitTx = '';
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9164/wa9164.component.ts